import { Injectable } from "@angular/core";

import { FiltroRicercaNotaVO } from "@app/shared/vo/filtro-ricerca-notaVO";

@Injectable({
  providedIn: "root",
})
export class FiltroRicercaNotaStore {
  private filtroRicercaNota: FiltroRicercaNotaVO;
  private filtroRicercaAvanzataNota: FiltroRicercaNotaVO;
  private filtroRicercaSempliceNota: FiltroRicercaNotaVO;
  private filtriSelezionabile: { [storeId: string]: FiltroRicercaNotaVO } = {};

  constructor() {
    this.filtroRicercaNota = null;
  }

  public setFiltroRicercaNota(filtroRicercaNota: FiltroRicercaNotaVO) {
    console.log(
      "[FiltroRicercaNotaStore][setFiltroRicercaNota]",
      filtroRicercaNota
    );
    this.filtroRicercaNota = filtroRicercaNota;
  }

  public getFiltroRicercaNota(): FiltroRicercaNotaVO {
    console.log(
      "[FiltroRicercaNotaStore][getFiltroRicercaNota]",
      this.filtroRicercaNota
    );
    return this.filtroRicercaNota;
  }

  public resetFiltroNota() {
    console.log("[FiltroRicercaNotaStore][resetFiltroNota]");
    this.filtroRicercaNota = undefined;
  }

  public getFiltroRicercaSempliceNota(): FiltroRicercaNotaVO {
    console.log(
      "[FiltroRicercaNotaStore][getFiltroRicercaNota]",
      this.filtroRicercaSempliceNota
    );
    return this.filtroRicercaSempliceNota;
  }

  public setFiltroRicercaSempliceNota(filtroRicercaNota: FiltroRicercaNotaVO) {
    console.log(
      "[FiltroRicercaNotaStore][setFiltroRicercaNota]",
      filtroRicercaNota
    );
    this.filtroRicercaSempliceNota = filtroRicercaNota;
  }

  public setFiltroRicercaAvanzataNota(filtroRicercaNota: FiltroRicercaNotaVO) {
    console.log(
      "[FiltroRicercaNotaStore][setFiltroRicercaAvanzataNota]",
      filtroRicercaNota
    );
    this.filtroRicercaAvanzataNota = filtroRicercaNota;
  }

  public getFiltroRicercaAvanzataNota(): FiltroRicercaNotaVO {
    console.log(
      "[FiltroRicercaNotaStore][getFiltroRicercaAvanzataNota]",
      this.filtroRicercaAvanzataNota
    );
    return this.filtroRicercaAvanzataNota;
  }

  public setFiltroSelezionabile(storeId: string, filtro: FiltroRicercaNotaVO): void {
    this.filtriSelezionabile[storeId] = filtro;
  }

  public getFiltroSelezionabile(storeId: string): FiltroRicercaNotaVO {
    return this.filtriSelezionabile[storeId] || null;
  }

  public resetFiltroSelezionabile(storeId: string): void {
    delete this.filtriSelezionabile[storeId];
  }
}
